module.exports = __webpack_public_path__ + "_/node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.eot?5a1bea7c7d256a5f6f8a55cbfa81c86b]";


//////////////////
// WEBPACK FOOTER
// ../node_modules/@catalytic/pushbot-ui-xtras/assets/fonts/NotoSansUI-BoldItalic.eot
// module id = 1881
// module chunks = 32